import React, {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import { Row,  Table } from 'reactstrap';
import ContactList from './ContactList';
import { ContactContext } from '../context/ContactContext';
import { useNavigate } from 'react-router-dom';
import { BiEditAlt, BiTrash } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom'
import { BiLeftArrowAlt } from 'react-icons/bi';
import useAuth from '../hooks/useAuth';

const ContactView = () => {
    const { auth } = useAuth();

    const [modal, openModal] = useState(false);
    const toggle = () => openModal(!modal);
    const [contacts, setContacts] = useState([]);
    const navigate = useNavigate();

    // const {contacts} = useContext(ContactContext);
    const handleDelete =  async (event, id) => {
        event.preventDefault();
        try {
            const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/contacts/delete-contact/${id}`,  {
                headers: {
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            });
            const res1 = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/contacts/find-all`);
            setContacts(res1.data);
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
        } catch (error) {
            error.response.data.message ? toast.error(error.response.data.message, {
                className: "error-toast",
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
                }) :  toast.error(error.response.data.error, {
                  className: "error-toast",
                  position: toast.POSITION.BOTTOM_RIGHT,
                  autoClose: 3000
              })
         }
    }
        

   
    useEffect(() => {
      const source = axios.CancelToken.source();
      const getContacts = async () => {
      try {
          const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/contacts/find-all`, {
              cancelToken: source.token
          });
          setContacts(res.data);
         
      } catch (error) {
              if (axios.isCancel(error)) {
                  console.log('cancelled');
              } else {
                  throw error;
              }
          }
      }
      
      getContacts();
      return () => {
          source.cancel();
      };
  },[])
    return (
        <div className="container">
          <Row sm="12">
            <h5 className="sec-header">Contact List</h5>
        </Row> 
        <Row>
            <Table responsive hover>
                <thead>
                <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Designation</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {
                    contacts.map(contact => (
                      <tr key={contact.id}>
                        {/* <ContactList contact={contact} /> */}
                            <td>{contact.id}</td>
                            <td>{contact.contactName}</td>
                            <td>{contact.designation}</td>
                            <td>{contact.phoneOne}</td>
                            <td>{contact.emailOne}</td>
                            <td>
                                <BiEditAlt className="edit_icon icon_hover" onClick={() => navigate(`/contacts/edit/${contact.id}`)} size={20}/> 
                                <BiTrash className="delete_icon icon_hover" onClick={(event) => handleDelete(event, contact.id)} size={20} />
                                
                                
                            </td>
                    </tr>
                  ))  
                }
                                
                </tbody>
            </Table>
     </Row>
     {
        contacts && <Row sm="12" className="mt-4 text-center">
          <Link to={"/contacts/add"} className="go_back" >
            <BiLeftArrowAlt size={30} />  Add Contact
          </Link>
      </Row> 
         }
        </div>
    )
   
}

export default ContactView;